import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

const $ = jQuery.noConflict();
export class ZIDXAccountLeadRouteEdit implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountLeadRouteEditContainer";
    }
    render(){
        // console.log("edit lead route");
        let self=this;
        let userSearchInput=$('.zidxAccountLeadRouteEditContainer #lead_routing_assign_to_user_id_input', self.zidx.peakidxShadowRoot);
        if(userSearchInput.length>0) {
            this.zidx.loadOnceFunctions.push(function () {
                // @ts-ignore
                $('.zidxAccountLeadRouteEditContainer #lead_routing_assign_to_user_id', self.zidx.peakidxShadowRoot).filterByText(userSearchInput, true);
            });
        }

        $("#lead_routing_type_id", self.zidx.peakidxShadowRoot).on("change", function(this:HTMLInputElement){
            $("#lead_routing_assign_to_email_fieldset", self.zidx.peakidxShadowRoot).hide();
            $("#lead_routing_assign_to_user_fieldset", self.zidx.peakidxShadowRoot).hide();
            $("#lead_routing_assign_to_round_robin_fieldset", self.zidx.peakidxShadowRoot).hide();
            $("#lead_routing_assign_to_team_fieldset", self.zidx.peakidxShadowRoot).hide();
            switch(this.value){
                case "1":
                    break;
                case "2":
                    $("#lead_routing_assign_to_user_fieldset", self.zidx.peakidxShadowRoot).show();
                    break;
                case "3":
                    $("#lead_routing_assign_to_email_fieldset", self.zidx.peakidxShadowRoot).show();
                    break;
                case "4":
                    $("#lead_routing_assign_to_round_robin_fieldset", self.zidx.peakidxShadowRoot).show();
                    break;
                case "5":
                    $("#lead_routing_assign_to_team_fieldset", self.zidx.peakidxShadowRoot).show();
                    break;
            }
        });
        $("#lead_routing_type_id", self.zidx.peakidxShadowRoot).trigger("change");
    }
}